import { render, staticRenderFns } from "./AddHospitalAdmin.vue?vue&type=template&id=73fc0ea4&scoped=true"
import script from "./AddHospitalAdmin.vue?vue&type=script&lang=js"
export * from "./AddHospitalAdmin.vue?vue&type=script&lang=js"
import style0 from "./AddHospitalAdmin.vue?vue&type=style&index=0&id=73fc0ea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fc0ea4",
  null
  
)

export default component.exports